import { useContext } from 'react'

import { IconButton, Tooltip, Typography } from '@mui/material'
import { Box } from '@mui/material'
import { IconBubbleText } from '@tabler/icons-react'

import ObjectAvatar from 'src/components/ObjectAvatar/ObjectAvatar'
import Row from 'src/components/Row/Row'
import { actionButtonStyle } from 'src/components/Sidebar/styles'
import { DayContext } from 'src/lib/dayContext'
import { logger } from 'src/lib/logger'
import { NativeObjectTypes } from 'src/lib/objects'
import { buildGqlObject, searchMetadataBuilders } from 'src/lib/Objects/build'

import useObject from '../useObject'

const SidebarHeader = () => {
  const { setSidebarObject } = useContext(DayContext)
  const { object, workspaceId } = useObject()
  const metadata = searchMetadataBuilders[object.objectType](object)
  const gqlObject = buildGqlObject(object)
  logger.dev('SidebarHeader', { gqlObject, object, metadata })

  return (
    metadata && (
      <Row className="header-row">
        <Row
          gap={2}
          sx={{ pt: 2 }}
        >
          <ObjectAvatar crmObject={gqlObject} />
          <Box>
            <Row className="object-title-row">
              <Row gap={1}>
                <Typography variant="h2">{metadata.label}</Typography>
                <Row className="sidebar-links-row"></Row>
              </Row>

              <Tooltip title={`Add context to ${metadata.label}`}>
                <IconButton
                  onClick={() => {
                    setSidebarObject({
                      mode: 'create',
                      objectType: NativeObjectTypes.UserContext,
                      objectId: 'CREATE',
                      workspaceId,
                      properties: {
                        parentReferenceKey: `${object.objectType} : ${object.objectId} : root`,
                        title: metadata.label,
                      },
                    })
                  }}
                  sx={actionButtonStyle}
                  className={'disable-elevation'}
                >
                  <IconBubbleText size={14} />
                </IconButton>
              </Tooltip>
            </Row>
            <Typography className="description">
              {metadata.description}
            </Typography>
          </Box>
        </Row>
      </Row>
    )
  )
}

export default SidebarHeader
